export enum FilterLSKeys {
  FILTER = 'FILTER',
}
